@if ((user$ | async); as user) {
  <div class="container">
    @if (!(isExpanded$ | async)) {
      <div class="section-title">
        {{'history' | transloco | uppercase}}
      </div>
    }
    <div class="content">
      <div class="scroll" #commentList>
        @if (comments.length > 0) {
          @for (comment of comments; track comment) {
            @if (comment.commentType === 1) {
              <comment-user
                [comment]="comment"
                [currentUser]="user"
              (contentHeightChanged)="onContentHeightChanged()"></comment-user>
            }
            @if (comment.commentType === 2) {
              <comment-system
              [comment]="comment"></comment-system>
            }
          }
        } @else {
          <div class="empty">
            {{ 'no_comments_yet' | transloco }}
          </div>
        }
      </div>
    </div>
    <div class="editor">
      <textarea placeholder="{{'comment' | transloco}}"
        #editor
        rows="1"
        (input)="onEditorInput(editor)"
        (keyup)="onEditorInput(editor)"
        (click)="onEditorInput(editor)"
        (focus)="onHandleFocus()"
      (focusout)="onFocusLeave()"></textarea>
      @if (mentionVisible) {
        <comment-mention
          class="mention-overlay"
          [users]="filteredMentionUsers"
          (userSelected)="insertMention($event, editor)">
        </comment-mention>
      }
      <upload-button
        #uploadComponent
        (uploadCompleted)="onUploadCompleted($event)"
        (uploadFailed)="onUploadFailed($event)">
      </upload-button>
      @if (!isPublishing) {
        <button mat-icon-button
          matTooltip="{{'add_comment' | transloco}}"
          [disabled]="!editor.value.trim() && uploadComponent.selectedFiles.length == 0"
          (click)="submit(uploadComponent)">
          <mat-icon>send</mat-icon>
        </button>
      }
    </div>
    @if (isLoading) {
      <div class="loader">
        <mat-spinner strokeWidth="4"></mat-spinner>
      </div>
    }
  </div>
}



